module.exports = __webpack_public_path__ + "static/media/screenshot_after.536c3912.png";